import { DataTable } from '@/components/DataTable/DataTable';
import { useTranslation } from 'react-i18next';
import { PersonAvatar, Tag } from '@teo/components';
import OptionsAction from './DataTable/OptionsAction';
import { nthLastIndexOf, newUid } from '@/util';
import i18n from 'i18next';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { useContext, useState } from 'react';
import { axios } from '@/axios';
import { config } from '@/config';
import ComponentDeleteModal from '@/components/DeleteModal/ComponentDeleteModal';

export const TeamsTableLP = ({ organisationId, ...other }: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [resetTeamTable, setResetTeamTable] = useState(newUid(20));
  const { auth } = useContext(AuthContext);
  const authUser: any = auth?.user;
  const managePath = `/${i18n.language}/manage/${organisationId}/teams`;
  const teamManageath = `/${i18n.language}/manage/${organisationId}/teams`;

  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [teamDelete, setTeamDelete] = useState<any>();

  const handleDeleteTeam = async (team: any) => {
    await axios.delete(
      `${config.backend}/lpteam/${other?.lpgroupId}/${team?.id}/`
    );
    other?.refetch();
    setResetTeamTable(newUid(20));

    setIsOpenDeleteModal(false);
  };

  const teamColumns: any = [
    {
      title: t('columns.teamName'),
      className: 'col-start-1 col-end-9',
      id: 'teamName',
      render: (team: any) => (
        <div className="flex items-center">
          <PersonAvatar
            inline
            id={team.id}
            name={team.teamName}
            bgColor={team.color ? team.color : null}
          ></PersonAvatar>
          {team.teamName}
        </div>
      ),
    },
    {
      addTitleOnMobile: true,
      className: 'col-start-1 col-end-8 row-start-2',
      id: 'nrOfTeamMembers',
      title: t('columns.nrOfTeamMembers'),
      align: 'right',
    },
    // {
    //   addTitleOnMobile: true,
    //   id: 'verified',
    //   title: t('columns.status'),
    //   sortable: false,
    //   className: 'col-start-7 col-end-10 row-start-2 text-right justify-end',
    //   align: 'right',
    //   classNameDesktop: 'max-w-[125px] w-[125px]',
    //   render: (team: any) => (
    //     <Tag
    //       title={
    //         team?.teamStatus === 'active'
    //           ? t('pages.manage_users.active')
    //           : t('pages.manage_users.not_active')
    //       }
    //       variant={team?.teamStatus === 'active' ? 'success' : 'error'}
    //     />
    //   ),
    // },
  ];

  if (
    Math.max(authUser?.role || 0, authUser?.activeOrganisationRole || 0) >= 90
  ) {
    teamColumns.push({
      id: 'actionButton',
      sortable: false,
      title: '',
      className: 'col-start-9 row-start-1 justify-end',
      classNameDesktop: 'max-w-[65px] w-[65px]',
      render: (team: any) => (
        <OptionsAction
          menuItems={[
            {
              addIcon: true,
              id: '1',
              title: t('pages.follow_up_users.manage_team'),
              onClick: () => navigate(`${managePath}/${team?.id}`),
            },
            {
              hidden: !other.teameCourse,
              id: '2',
              title: t('pages.follow_up_users.delete_team'),
              onClick: () => {
                setIsOpenDeleteModal(true);
                setTeamDelete(team);
              },
            },
          ]}
          rowInfo={team}
          screensUpdateTable="desktop"
          pageDetail={{
            title: t('pages.follow_up_users.manage_team'),
            rowPath: (team) => `${teamManageath}/${team.id}`,
          }}
          mobileHeader={{
            render: (team: any) => (
              <div className="flex items-center">
                <PersonAvatar
                  inline
                  id={team.id}
                  name={team.teamName}
                  bgColor={team.color ? team.color : null}
                ></PersonAvatar>
                <p className="text-[12px] font-medium text-[#231f20] sm:text-sm">
                  {team.teamName}
                </p>
              </div>
            ),
          }}
        />
      ),
    });
  }

  return (
    <>
      <DataTable
        key={resetTeamTable}
        rowPath={other.rowPath}
        defaultSort={[{ id: 'teamPath', desc: false }]}
        screensUpdateTable="desktop"
        columns={teamColumns}
        {...other}
      />

      {isOpenDeleteModal && (
        <ComponentDeleteModal
          closeModal={() => setIsOpenDeleteModal(false)}
          setIsOpenDeleteModal={setIsOpenDeleteModal}
          title={t('delete_modal.title_team') + teamDelete?.teamName}
          heading={t('delete_modal.heading_team')}
          text={t('delete_modal.text_team_lp')}
          handleDelete={() => handleDeleteTeam(teamDelete)}
        />
      )}
    </>
  );
};
